import 'jquery/isotope';
import * as $ from 'jquery';
import * as kendo from 'kendo/kendo.core';
import * as UserShipLinkDatasource from 'visuris/Data/Datasources/Related/UserShipLinkDatasource';
import Event, { IEvent } from 'visuris/Event';
import ShipLink from '../../Data/Entities/ShipLink';

export interface VesselsInitializeOptions {
    canSelect: boolean;
    canManage: boolean;
}
export default class Vessels {
    private $vesselsContainer: JQuery;
    private vesselItemTemplate: (data: any) => string;
    private kendoListView: kendo.ui.ListView;

    public selected: IEvent<ShipLink> = new Event<ShipLink>();

    constructor() {
    }

    public async initialize(container: HTMLElement, options: VesselsInitializeOptions): Promise<JQuery<HTMLElement>> {
        this.vesselItemTemplate = kendo.template(await import('text!visuris/UI/Vessels/Vessel.html'));
        let that = this;
        this.$vesselsContainer = $(container).find('.vessels-container');

        this.$vesselsContainer.kendoListView({
            template: this.vesselItemTemplate,
            selectable: options.canSelect ? 'single': false,
            dataSource: UserShipLinkDatasource.create(null, null, true),
            dataBound: e => {
                if (!options.canManage) {
                    const $titleContainer = this.$vesselsContainer.find('.title-container');
                    $titleContainer.find('.btn-delete').remove();
                    $titleContainer.find('.btn-edit').remove();
                }
            },
            change: e => {
                (this.selected as Event<ShipLink>).trigger(this.getSelected());
            }
        });
        this.kendoListView = this.$vesselsContainer.data('kendoListView');

        $(container).find('.input-search').on("input", function () {
            const filterValue = $(this).val() as string;
            that.filter(filterValue);
        });

        return $(container);
    }
    public getSelected(): ShipLink {
        if (this.kendoListView.select()) {
            return this.kendoListView.dataItem(this.kendoListView.select()) as any as ShipLink;
        }
        return null;
    }

    public filter(searchText: string) {
        this.kendoListView.dataSource.filter({
            field: "shipName",
            operator: "contains",
            value: searchText
        });
    }
}